// ISSUE-1299. A Strip Card pool with no league, after v1's "Custom" league.
// The pool row still carries a league and a sport key, so every read that
// keys on them keeps working, but the value is this marker and never a real
// sports-api league: no season lookup, no schedule, no feed. Every game in
// such a pool is a custom game the Commissioner names. A real league key is
// always "<sport>-<slug>" (services/sports-api/src/models/leagues.ts), so the
// marker can never collide with one.

/** The leagueKey of a pool created with no league. */
export const CUSTOM_LEAGUE_KEY = "custom";

/** The sportKey of a pool created with no league. */
export const CUSTOM_SPORT_KEY = "custom";

/** What a fan reads where a league name would sit. */
export const CUSTOM_LEAGUE_LABEL = "Custom";

/** The pool types that can be created with no league. */
export const CUSTOM_LEAGUE_CONTEST_TYPES = ["stripCard"] as const;

/** True for the no-league marker. */
export function isCustomLeagueKey(
  leagueKey: string | null | undefined,
): boolean {
  return leagueKey === CUSTOM_LEAGUE_KEY;
}

/** True when a pool type can be created with no league. */
export function allowsCustomLeague(contestType: string): boolean {
  return (CUSTOM_LEAGUE_CONTEST_TYPES as readonly string[]).includes(
    contestType,
  );
}
